import { ReactNode, forwardRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Trans } from 'react-i18next'
import cn from 'classnames/bind'

import PlainNav, { NavItem } from 'app/common/ui/PlainNav'
import getRegAvailable from 'app/selectors/getRegAvailable'

import selectNavigationAvalilability from './selectNavigationAvalilability'
import styles from './Navigation.scss'

const cx = cn.bind(styles)

export type Availability = {
  isMyAvailable: boolean
  isChildrenAvailable: boolean
}

type Props = {
  currentStudentId: number
  children?: ReactNode
  onRedirect?: (path: string) => void
  showRefill: boolean
  showTransfer: boolean
  className?: string
  shadow?: boolean
}

const Navigation = forwardRef<HTMLDivElement, Props>(
  (
    { currentStudentId, children, onRedirect, showRefill, showTransfer, className, shadow }: Props,
    ref,
  ) => {
    const availability: Availability = useSelector(selectNavigationAvalilability)
    const externalCafe: boolean = useSelector(getRegAvailable)

    useEffect(() => {
      if (!availability.isMyAvailable && onRedirect) {
        onRedirect('/children')
      }
    }, [availability.isMyAvailable]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <div className={cx(styles.navbar, { shadow }, className)} ref={ref}>
        <PlainNav className={styles.menuLeft}>
          {availability.isMyAvailable && (
            <NavItem to="/finances/my/">
              {externalCafe ? (
                <Trans i18nKey="finances:menu_item1_alt">{'Финансы оповещений'}</Trans>
              ) : (
                <Trans i18nKey="finances:menu_item1">{'Мои финансы'}</Trans>
              )}
            </NavItem>
          )}

          {!!currentStudentId && availability.isChildrenAvailable && (
            <NavItem to={`/apps/${currentStudentId}/cafeteria/general/finances`}>
              {externalCafe ? (
                <Trans i18nKey="finances:menu_item2_alt">{'Финансы питания'}</Trans>
              ) : (
                <Trans i18nKey="finances:menu_item2">{'Финансы детей'}</Trans>
              )}
            </NavItem>
          )}

          <NavItem to={`/apps/${currentStudentId}/cafeteria/general/paymentOrders`}>
            <Trans i18nKey="finances:finances_payment_orders_link_title">{'Квитанции'}</Trans>
          </NavItem>
        </PlainNav>

        <PlainNav>
          {(showRefill || showTransfer) && (
            <NavItem to="/finances/fund">
              {showTransfer ? (
                <Trans i18nKey="finances:menu_item3">{'Пополнить счет или перевести'}</Trans>
              ) : (
                <Trans i18nKey="finances:menu_item3_alt">{'Пополнить счет'}</Trans>
              )}
            </NavItem>
          )}
        </PlainNav>

        {children}
      </div>
    )
  },
)

export default Navigation
